import {OrderEventStore} from "./event/OrderEventStore";
import {OrderStore} from "./order/OrderStore";
import {OrderViewStore} from "./view/OrderViewStore";
import {IressOrderViewModelFactory} from "./view/IressOrderViewModelFactory";
import {OrderQuoteSourceBuilder} from "./view/OrderQuoteSourceBuilder";
import {SimulatedOrderViewModelFactory} from "./view/SimulatedOrderViewModelFactory";
import {TmcLegViewModelFactory} from "./view/TmcLegViewModelFactory";
import {PlacedOrdersStore} from "./placed/PlacedOrdersStore";

export default angular.module("tfApp.order.store", [])
                      .service(OrderEventStore.id, OrderEventStore)
                      .service(OrderStore.id, OrderStore)
                      .service(OrderViewStore.id, OrderViewStore)
                      .service(IressOrderViewModelFactory.id, IressOrderViewModelFactory)
                      .service(SimulatedOrderViewModelFactory.id, SimulatedOrderViewModelFactory)
                      .service(TmcLegViewModelFactory.id, TmcLegViewModelFactory)
                      .service(OrderQuoteSourceBuilder.id, OrderQuoteSourceBuilder)
                      .service(PlacedOrdersStore.id, PlacedOrdersStore)
                      .name;
